import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DsButton } from '@frontend/ui/button';
import { DsModal, DsModalContent, DsModalHeader } from '@frontend/ui/modal';
import { Subject } from 'rxjs';

import { TournamentUnfinishedGames, UnfinishedPopupText } from '../slotrace-game.model';

@Component({
    selector: 'cc-unfinished-games-popup',
    templateUrl: './unfinished-games-popup.component.html',
    styleUrls: ['./unfinished-games-popup.component.scss'],
    imports: [DsButton, DsModal, DsModalContent, DsModalHeader],
})
export class UnfinishedGamesPopupComponent {
    tournamentUnfinishedGames: TournamentUnfinishedGames[];
    unfinishedPopuUpText: UnfinishedPopupText;
    preventIconSrc: string;
    radialShadowSrc: string;
    dialogRef = inject(MatDialogRef<UnfinishedGamesPopupComponent>);
    unfinishedGamePopUpData = inject(MAT_DIALOG_DATA) as {
        launchGameEmitter: Subject<string>;
        unfinishedGamesData: TournamentUnfinishedGames[];
        unfinishedPopuUpText: UnfinishedPopupText;
        preventIconSrc: string;
        radialShadowSrc: string;
    };

    constructor() {
        this.tournamentUnfinishedGames = [...this.unfinishedGamePopUpData.unfinishedGamesData];
        this.unfinishedPopuUpText = this.unfinishedGamePopUpData?.unfinishedPopuUpText;
        this.preventIconSrc = this.unfinishedGamePopUpData.preventIconSrc;
        this.radialShadowSrc = this.unfinishedGamePopUpData.radialShadowSrc;
    }

    get preventPopupTitle(): string {
        return this.unfinishedPopuUpText?.preventPopupTitle ?? 'Game Rounds in Progress';
    }

    get preventPopupClose(): string {
        return this.unfinishedPopuUpText?.preventPopupClose ?? 'Close';
    }

    get preventPopupSingleGameDescription(): string {
        return (
            this.unfinishedPopuUpText?.preventPopupSingleGameDescription ??
            'It looks like you have an unfinished game round. Before you can join a tournament, you need to complete this active round.'
        );
    }

    get preventPopupMultipleGameDescription(): string {
        return (
            this.unfinishedPopuUpText?.preventPopupMultipleGameDescription ??
            'It looks like you have a couple of unfinished game rounds. Before you can join a tournament, you need to complete those active rounds.'
        );
    }

    get preventPopupLaunchUnfinishedGame(): string {
        return this.unfinishedPopuUpText?.preventPopupLaunchUnfinishedGame ?? 'Complete first round';
    }

    close(): void {
        this.dialogRef.close(null);
    }

    launchUnfinishedGame(gameId: string) {
        if (gameId) {
            this.dialogRef.close(gameId);
        }
    }
}
